var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 9.06C24.8933 3.885 20.8533 0 16 0C12.1467 0 8.8 2.46 7.13333 6.06C3.12 6.54 0 10.365 0 15C0 19.965 3.58667 24 8 24H25.3333C29.0133 24 32 20.64 32 16.5C32 12.54 29.2667 9.33 25.8 9.06ZM18.6667 13.5V19.5H13.3333V13.5H9.33333L16 6L22.6667 13.5H18.6667Z",
    fill: "#0B2456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.d6f4f781.svg";
export { ForwardRef as ReactComponent };